import { Banner, ClViewer, Logout } from 'components/shard'
import React, { useState } from 'react'
import styled from 'styled-components'
import { Color, Size } from 'const'
import { MEDIA_QUERY } from 'config/constants'
import serviceAPI from 'utils/axios/modules/service'
import { Sunglasses, Frame, Lens, Contact } from 'components/shard/ProductInfo'
import _ from 'lodash'
import Spinner from 'components/shard/spinner'
import { useLocation } from 'react-router-dom'
import { useQuery } from 'react-query'
import { isBeforeOrEqualMock } from 'utils/helpers/function'

const ProductInfoPage = () => {
  const { state } = useLocation()

  const [productInfo, setProductInfo] = useState({
    items: {
      sungalsses: {
        brand: '―',
        design: '',
        color: '',
        function: null,
        material: '',
        name: '',
        part_no: '',
        price: null,
        purchase_detail_id: '',
        dev_sales_date: '',
      },
      lens_r: {
        name_r: '―',
        price_r: 0,
        material_r: null,
        design_r: null,
        function_r: null,
        sph_r: '0',
        cyl_r: '0',
        add_r: '0',
        axis_r: null,
        pd_r: null,
        dev_sales_date: '',
      },
      lens_l: {
        name_l: '―',
        price_l: 0,
        material_l: null,
        design_l: null,
        function_l: null,
        sph_l: '0',
        cyl_l: '0',
        add_l: '0',
        axis_l: null,
        pd_l: null,
        dev_sales_date: '',
      },
      contact_lens_r: {
        purchase_detail_id: '',
        brand: '―',
        price: 0,
        part_no: '',
        name: '',
        focus: '',
        type: '',
        material: '',
        size: '',
        base_curve: '',
        lens_color: null,
        sph: null,
        cyl: null,
        add: null,
        ax: null,
        pd: null,
        quantity: 0,
        warranty: null,
        dev_sales_date: '',
      },
      contact_lens_l: {
        purchase_detail_id: '',
        brand: '―',
        price: 0,
        part_no: '',
        name: '',
        focus: '',
        type: '',
        material: '',
        size: '',
        base_curve: '',
        lens_color: null,
        sph: null,
        cyl: null,
        add: null,
        ax: null,
        pd: null,
        quantity: 0,
        warranty: null,
        dev_sales_date: '',
      },
    },
  })

  const { isLoading, isError } = useQuery({
    queryKey: ['getProducts', state],
    queryFn: ({ signal }) => serviceAPI.getProducts(state?.contractId, state?.purchase_detail_ids, signal),
    enabled: !_.isEmpty(state),
    onSuccess(response) {
      setProductInfo(response.data)
    },
    refetchOnWindowFocus: false,
    retry: (failureCount, error) => {
      if (failureCount === 3) return false

      return true
    },
  })

  const salesDates = _.values(productInfo.items).map((item) => item.dev_sales_date)

  const isSameSalesDate = salesDates.every((salesDate, idx, arr) => _.isEqual(salesDate, arr[0]))

  const isBeforeOrEqual31thMarch2025 = isBeforeOrEqualMock(salesDates[0], '2025-03-31')

  const isContactLens =
    productInfo.items.contact_lens_l?.brand ||
    productInfo.items.contact_lens_l?.name ||
    productInfo.items.contact_lens_r?.brand ||
    productInfo.items.contact_lens_r?.name

  const defaultLens = {
    brand: '―',
    name: '',
    type: '',
  }

  return (
    <React.Fragment>
      {isLoading && (
        <LoadingContainer>
          <Spinner />
        </LoadingContainer>
      )}
      {isError && !isLoading && <BoxEmpty>データがありません</BoxEmpty>}
      {!isLoading && !isError && (
        <StyledPurchaseDetail>
          <div className="section-label">
            <h2>商品詳細</h2>
          </div>
          <div className="item_detail_wrapper">
            <ItemWrapper>
              <Frame content={productInfo.items.frame} isSameSalesDate={isSameSalesDate} />
            </ItemWrapper>
            <Sunglasses content={productInfo.items.sungalsses} isSameSalesDate={isSameSalesDate} />
            <Lens
              content_l={_.get(productInfo.items, 'lens_l', defaultLens)}
              content_r={_.get(productInfo.items, 'lens_r', defaultLens)}
              isSameSalesDate={isSameSalesDate}
            />
            <Contact
              content_l={_.get(productInfo.items, 'contact_lens_l', defaultLens)}
              content_r={_.get(productInfo.items, 'contact_lens_r', defaultLens)}
              isSameSalesDate={isSameSalesDate}
            />
          </div>
          {isSameSalesDate && (
            <ClViewer
              isBeforeOrEqual31thMarch2025={isBeforeOrEqual31thMarch2025}
              isContactLens={isContactLens}
              custom={false}
            />
          )}
        </StyledPurchaseDetail>
      )}
      <Banner />
      <Logout />
    </React.Fragment>
  )
}

const BoxEmpty = styled.div`
  text-align: center;
  border-radius: 10px;
  border: 1px solid ${Color.LINE.NORMAL};
  padding: 30px 0;
`

const StyledPurchaseDetail = styled.div`
  padding: 0 24px;
  margin-bottom: 60px;

  ${MEDIA_QUERY.SP} {
    padding: 0 20px;
    border-radius: 0;
    border: none;
  }
  > .section-label {
    display: flex;
    align-items: center;
    margin: 0 -20px;
    padding: 12px 20px;
    background-color: ${Color.GREY};
    > h2 {
      font-weight: 700;
      font-size: ${Size.FONT.BIGGER};
      &.top {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
      }
    }
  }

  > .history_detail_wrapper {
    margin: 30px 0;
    ${MEDIA_QUERY.SP} {
      margin: 0;
    }
    > .row {
      display: flex;
      margin-bottom: 15px;
      ${MEDIA_QUERY.SP} {
        display: block;
        margin-bottom: 0;
        padding: 16px 0;
        + .row {
          border-top: solid 1px #f4f4f4;
        }
      }
      > .label {
        width: 160px;
        margin-right: 24px;
        ${MEDIA_QUERY.SP} {
          text-align: left;
          margin-bottom: 8px;
        }
        font-weight: 700;
        font-size: ${Size.FONT.BIG};
      }
      > .content {
        ${MEDIA_QUERY.SP} {
          white-space: pre-wrap;
        }
        font-size: ${Size.FONT.BIG};
      }
    }
  }
  > .item_detail_wrapper {
    margin-bottom: 30px;
    ${MEDIA_QUERY.SP} {
      margin-bottom: 40px;
    }
  }

  > .button_and_download_wrapper {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 40px 0 30px;
    > a {
      line-height: 24px;
      margin-top: 20px;
    }
  }

  > .download_caution {
    text-align: center;
    margin: 20px 0;
  }
`
// const Separator = styled.div`
//   height: 1px;
//   background-color: ${Color.GREY};
// `

const ItemWrapper = styled.div``

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
`

export default ProductInfoPage
